import { render, staticRenderFns } from "./AlvoradaCarater.vue?vue&type=template&id=319b96cc&scoped=true"
import script from "./AlvoradaCarater.vue?vue&type=script&lang=ts"
export * from "./AlvoradaCarater.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b96cc",
  null
  
)

export default component.exports